import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(performanceDataSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(performanceListener),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(inventoryPerformanceDataSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(inventoryPerformanceDataListener);

import { put, select, takeLatest } from 'redux-saga/effects';
import applyUrlParams from '@signal/utils/applyUrlParams';
import createRequestSaga from '@signal/utils/createRequestSaga';
import { setDateRange, dateRangeSelector } from '../local';
import api from '../api';
import { activeAccountIdSelector } from '../auth/selectors';
import { performanceDataActions, performanceDataLoad, inventoryPerformanceDataActions, inventoryPerformanceDataLoad } from './actions';
import { isLoadingSelector, isLoadedSelector, isInventoryPerformanceDataLoadingSelector, isInventoryPerformanceDataLoadedSelector } from './selectors';
/**
 * Channel Performance Sagas
 */

export var PERFORMANCE_DATA_API_ENDPOINT = '/attribution';
export function performanceDataSaga() {
  var _yield$select, start, end, accountId;

  return _regeneratorRuntime.wrap(function performanceDataSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(dateRangeSelector);

        case 2:
          _yield$select = _context.sent;
          start = _yield$select.start;
          end = _yield$select.end;
          _context.next = 7;
          return select(activeAccountIdSelector);

        case 7:
          accountId = _context.sent;
          _context.next = 10;
          return put(api.get(performanceDataActions, applyUrlParams("".concat(PERFORMANCE_DATA_API_ENDPOINT, "/").concat(accountId), {
            start: start,
            end: end
          })));

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export var loadPerformanceData = createRequestSaga(performanceDataActions, {
  loadingSelector: isLoadingSelector,
  loadedSelector: isLoadedSelector
});
export function performanceListener() {
  return _regeneratorRuntime.wrap(function performanceListener$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest([performanceDataLoad, setDateRange], performanceDataSaga);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Inventory Performance Sagas
 */

export var INVENTORY_PERFORMANCE_DATA_API_ENDPOINT = '/inventory';
export function inventoryPerformanceDataSaga() {
  var accountId;
  return _regeneratorRuntime.wrap(function inventoryPerformanceDataSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(activeAccountIdSelector);

        case 2:
          accountId = _context3.sent;
          _context3.next = 5;
          return put(api.get(inventoryPerformanceDataActions, "".concat(INVENTORY_PERFORMANCE_DATA_API_ENDPOINT, "/").concat(accountId)));

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export var loadInventoryPerformanceData = createRequestSaga(inventoryPerformanceDataActions, {
  loadingSelector: isInventoryPerformanceDataLoadingSelector,
  loadedSelector: isInventoryPerformanceDataLoadedSelector
});
export function inventoryPerformanceDataListener() {
  return _regeneratorRuntime.wrap(function inventoryPerformanceDataListener$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(inventoryPerformanceDataLoad.getType(), inventoryPerformanceDataSaga);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}